import React from 'react';
import Container from '../../Container';

const ModelInteractorEmptyView = ({ children }) => (
  <Container flex horziontal center alignCenter>{children}</Container>
);

export default ModelInteractorEmptyView;
